import { Button } from '../../../../components/Button/Button';
import {
  ProSignUpSuccessMessageBlockErrorMessage,
  ProSignUpSuccessMessageBlockSubTitle,
  ProSignUpSuccessMessageBlockSuccessMessage,
  ProSignUpSuccessMessageBlockTitle,
  ProSignUpSuccessMessageBlockWrapper,
} from './ProSignUpSuccessMessageBlock.styles';
import { useState } from 'react';
import { ServiceOSApiClient } from '../../../../utils/serviceOSApiClient';
import { ProSignUpSuccessMessageBlockProps } from './ProSignUpSuccessMessageBlock.types';
import { StoryblokComponent } from '@storyblok/react';
import { useRouter } from 'next/router';
import { patchedStoryblokEditable } from '../../../../utils/patchedStoryblokEditable';

export const POST_SIGN_UP_SERVICEOS_EMAIL_QUERY_PARAM = 'post_signup_sos_email';

const serviceOSApiClient = new ServiceOSApiClient();

export const ProSignUpSuccessMessageBlock = (props: ProSignUpSuccessMessageBlockProps) => {
  const { blok } = props;
  const { title, subtitle, resendButtonText, notReceivedButtonText } = blok;

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const router = useRouter();

  const handleResendClick = async () => {
    setErrorMessage(null);
    setSuccessMessage(null);

    const email = router.query[POST_SIGN_UP_SERVICEOS_EMAIL_QUERY_PARAM];

    if (!email) {
      setErrorMessage('No email provided');
      return;
    }

    const { successMessage, errorMessage } = await serviceOSApiClient.resendEmailVerification(
      email as string
    );

    if (errorMessage) {
      setErrorMessage(errorMessage);
    } else if (successMessage) {
      setSuccessMessage(successMessage);
    }
  };

  return (
    <ProSignUpSuccessMessageBlockWrapper {...patchedStoryblokEditable(blok)}>
      {title?.length > 0 && (
        <ProSignUpSuccessMessageBlockTitle>
          <StoryblokComponent blok={title[0]} />
        </ProSignUpSuccessMessageBlockTitle>
      )}
      {subtitle?.length > 0 && (
        <ProSignUpSuccessMessageBlockSubTitle>
          <StoryblokComponent blok={subtitle[0]} />
        </ProSignUpSuccessMessageBlockSubTitle>
      )}

      <Button
        text={resendButtonText}
        variant="filledBlue"
        fullWidth
        shrink
        onClickHandler={handleResendClick}
      />
      <Button
        text={notReceivedButtonText}
        variant="text"
        fullWidth
        shrink
        url="mailto:info@urban.co"
      />

      {!!errorMessage && (
        <ProSignUpSuccessMessageBlockErrorMessage>
          {errorMessage}
        </ProSignUpSuccessMessageBlockErrorMessage>
      )}
      {!!successMessage && (
        <ProSignUpSuccessMessageBlockSuccessMessage>
          {successMessage}
        </ProSignUpSuccessMessageBlockSuccessMessage>
      )}
    </ProSignUpSuccessMessageBlockWrapper>
  );
};
